var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbCall2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ib-call2-icon_svg__clip0_1296_2476)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0a3 3 0 00-2.236 1H3a3 3 0 00-3 3v12a3 3 0 003 3h9.764A3 3 0 0015 20h2a3 3 0 003-3V3a3 3 0 00-3-3h-2zm-1 17a1 1 0 001 1h2a1 1 0 001-1V3a1 1 0 00-1-1h-2a1 1 0 00-1 1v14zM11 5a1 1 0 00-1-1H4a1 1 0 00-1 1v1a1 1 0 001 1h6a1 1 0 001-1V5zm-7 5a1 1 0 011 1v.01a1 1 0 11-2 0V11a1 1 0 011-1zm3 0a1 1 0 011 1v.01a1 1 0 11-2 0V11a1 1 0 011-1zm4 1a1 1 0 10-2 0v.01a1 1 0 102 0V11zm-1 3a1 1 0 011 1v.01a1 1 0 11-2 0V15a1 1 0 011-1zm-3 0a1 1 0 011 1v.01a1 1 0 11-2 0V15a1 1 0 011-1zm-3 0a1 1 0 011 1v.01a1 1 0 11-2 0V15a1 1 0 011-1z",
    fill: "#1C1D1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ib-call2-icon_svg__clip0_1296_2476"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgIbCall2Icon;